import React from "react";
// import Scrollbars from "react-custom-scrollbars";
import { ReactComponent as CancelIcon } from "../../../../assets/svg/close.svg";
// import QueryResults from "../../../MainContent/queryBuilder/components/queryResults/QueryResults";

const MobileVersionQueryBuilder = (props) => {
    const {
        genericKeyword,
        handleGenericChange,
        // showSampleButtonState,
        handleKeyWordChange,
        // rawData,
        // queryResults,
        // queryResultsLoading,
        keywords,
        clearKeyword,
        // showSamplePosts,
        // handleValidateButton,
        // setSetupModeSampleButton,
        finalQuery,
    } = props;
    // const [isDirty, setIsDirty] = useState(false);
    // const disableSampleButton = () => {
    //     // setSetupModeSampleButton(true);
    // };
    return (
        <div className="mobile__version__query__builder">
            <p className="header__text-keyword">Include Keywords you want to track</p>
            <p className="header__text-keyword">Contains</p>
            <div className="keyword__add-field">
                <input
                    // onClick={disableSampleButton}
                    type="text"
                    value={keywords[0]["keyword"]}
                    className="input__field"
                    placeholder="Enter Keyword Ex:Apple"
                    onChange={(ev) => handleKeyWordChange(ev, 0)}
                    id={keywords[0]["id"]}
                    autoComplete="off"
                />
                {keywords[0]["keyword"].length > 0 ? <CancelIcon onClick={() => clearKeyword(0, "keywords")} /> : <span></span>}
            </div>
            {keywords.length > 1 && (
                <>
                    <div className="booleans__center__align">OR</div>

                    <div className="keyword__add-field">
                        <input
                            // onClick={disableSampleButton}
                            type="text"
                            value={keywords[1]["keyword"]}
                            className="input__field"
                            placeholder="Enter Keyword Ex:iPad"
                            onChange={(ev) => handleKeyWordChange(ev, 1)}
                            // onKeyPress={(ev) => handleKeyPress(ev, "genericKeyword")}
                            id={keywords[1]["id"]}
                            autoComplete="off"
                        />
                        {keywords[1]["keyword"].length > 0 ? <CancelIcon onClick={() => clearKeyword(1, "keywords")} /> : <span></span>}
                    </div>
                </>
            )}

            <div className="booleans__center__align">AND</div>
            <p className="header__text-keyword">Also contains</p>

            {genericKeyword.map((ele, ind) => {
                return (
                    <div className="keyword__add-field" key={ind}>
                        <input
                            type="text"
                            value={genericKeyword[ind]["keyword"]}
                            className="input__field"
                            placeholder="Enter Keyword Ex:iPhone"
                            onChange={(ev) => handleGenericChange(ev, ind)}
                            id={genericKeyword[ind]["id"]}
                            autoComplete="off"
                        />
                        {genericKeyword[ind]["keyword"].length > 0 ? <CancelIcon onClick={() => clearKeyword(ind, "genericKeyword")} /> : <span></span>}
                    </div>
                );
            })}
            <div className={`easy__query__heading mobile__version__heading`}>Your Query</div>

            <textarea value={finalQuery} disabled={true} className="text__area__mobile__version" placeholder={`("Apple" OR "iPad") AND ("iPhone")`}></textarea>

            {/* {isDirty && (
                <div className="mobile__show__sample__data__block">
                    {rawData == 0 && queryResults.total === 0 && <div className="no-posts">No Data</div>}
                    {<QueryResults rawData={rawData} queryResultsLoading={queryResultsLoading} />}
                </div>
            )} */}

            {/* <div className="button__container"> */}
            {/* <button
                    className="validate__button"
                    onClick={() => {
                        handleValidateButton();
                    }}>
                    Validate Query
                </button> */}
            {/* <button
                    className="show__sample-btn qb_step9"
                    disabled={showSampleButtonState}
                    onClick={() => {
                        setIsDirty(true);
                        showSamplePosts();
                    }}>
                    Show Sample Data
                </button> */}
            {/* </div> */}
        </div>
    );
};

export default MobileVersionQueryBuilder;
